import React from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

export default function UserDelete({
  setModal,
  currentComponent,
  deleteComponent,
  itemType,
  modalTitle,
}) 
{
  console.log(currentComponent,"cureent")
  return (
    <>
      <ModalHeader toggle={() => setModal((state) => !state)}>
        Delete {modalTitle}
      </ModalHeader>
      <ModalBody>
        Permanently delete {itemType} <strong>{currentComponent?.full_name}</strong>?
      </ModalBody>
      <ModalFooter>
      <Button color="secondary" onClick={() => setModal((state) => !state)}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => {
            setModal((state) => !state);
            deleteComponent();
          }}
        >
          Yes
        </Button>
       
      </ModalFooter>
    </>
  );
}
